import { Box, TablePagination } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface PaginationCompProps {
  page: number;
  handlePageChange: (value: number) => void;
  count: number;
  limit: number;
  handleLimitChange: (lmit: number) => void;
  isCardsView?: boolean;
}

export const PaginationComp = (props: PaginationCompProps) => {
  const { page, handlePageChange, count, limit, handleLimitChange, isCardsView } = props;
  const { t }: { t: any } = useTranslation();
  const rowsPerPageOptionsFinal = isCardsView ? [12, 24, 48] : [25, 50, 100];

  return (
    <Box p={2}>
      <TablePagination
        component="div"
        count={count}
        onPageChange={(event, page) => handlePageChange(page)}
        // onRowsPerPageChange={(event) => handleLimitChange(event.target.value)}
        onRowsPerPageChange={(event) => {
          const newLimit = parseInt(event.target.value, 10);
          handleLimitChange(newLimit);
        }}
        page={page}
        rowsPerPage={limit}
        rowsPerPageOptions={rowsPerPageOptionsFinal}
        labelRowsPerPage={t('Rows per page:')}
        sx={{
          '& .MuiTablePagination-toolbar .MuiInputBase-root': {
            fontWeight: 'bold',
          },
        }}
      />
    </Box>
  );
};
